import React from 'react';

function SMCModalButtonContainer({
    children,
    left,
    right,
    size
}) {
    return (
        <div className={size === 'small' ? 'WizButtonsSmall' : 'WizButtons'}>
            <hr />
            {
                <div className="WizButtonsContainer">
                    { children }
                    { right }
                </div>
            }
            { left && (
                <div className="LeftWizButtonsContainer">
                    {left}
                </div>
            )}
        </div>
    );
}

export default SMCModalButtonContainer;